const state={
  userInfo:{}
}
const mutations = {
  SET_USER(state, userInfo){
    state.userInfo = userInfo;
  }
}

const actions = {
  set_user({ commit }, data){
    commit('SET_USER', data)
  }
}
export default {
  state,
  mutations,
  actions
}